"use strict";

angular.module('app.shared.services')
    .factory("permissionService", permissionService);

permissionService.$inject = ['$http', '$q', '$window', 'httpRequest', 'appGlobals', 'sessionService'];

function permissionService($http, $q, $window, httpRequest, appGlobals, sessionService) {
    var baseurl = appGlobals.baseApiUrl;
    var url = "";

    var taskperms = null;
    var eventperms = null;
    var jobperms = null;

    var dasheventperms = null;

    var task;
    var module;
    var menugroup;
    var grouptaskperms = null;

    var currentUser = null;
    var userid = null;
    var erpkey = null;
    var lockey = null;
    var nextTask = {};

    function init() {

        if (sessionService.getCurrentUser() != null) {
            currentUser = sessionService.getCurrentUser();
            userid = currentUser.UserID;
            erpkey = currentUser.ERPKey;
            lockey = currentUser.LocKey;
        }

    }

    var setModule = function (moduleKey) {
        module = moduleKey;
    };

    var getModule = function () {
        return module;
    };

    var setMenuGroup = function (groupKey) {
        menugroup = groupKey;
    };

    var getMenuGroup = function () {
        return menugroup;
    };

    var setNextTask = function (args) {
        nextTask = args;
    };

    var getNextTask = function () {
        return nextTask;
    };

    var requestTaskPermByModule = function (modulekey) {
        var url = baseurl + "usertaskperms/GetByModule?userid=" + currentUser.UserID + "&lockey=" + lockey + "&modulekey=" + modulekey;
        return httpRequest.doGetRequest(url)
    };

    var requestEventPermByModule = function (modulekey) {
        var url = baseurl + "usersecureventperms/GetByModule?userid=" + currentUser.UserID + "&lockey=" + lockey + "&modulekey=" + modulekey;
        return httpRequest.doGetRequest(url)
    };

    var requestTaskPermByMenuGroup = function (groupkey) {
        var url = baseurl + "usertaskperms/GetByMenuGroup?userid=" + currentUser.UserID + "&lockey=" + lockey + "&groupkey=" + groupkey;
        return httpRequest.doGetRequest(url)
    };

    var requestEventPermByMenuGroup = function (groupkey) {
        var url = baseurl + "usersecureventperms/GetByMenuGroup?userid=" + currentUser.UserID + "&lockey=" + lockey + "&groupkey=" + groupkey;
        return httpRequest.doGetRequest(url)
    };

    var requestJobPerms = function () {
        var url = baseurl + "userjobperms/GetByUser" + "?userid=" + currentUser.UserID + "&erpkey=" + erpkey;
        return httpRequest.doGetRequest(url)
    };

    var requestAdditionalTaskPerm = function (taskKey) {
        var url = baseurl + "usertaskperms/GetSUMLTaskPerms?userid=" + currentUser.UserID + "&lockey=" + lockey + "&taskey=" + taskKey;
        return httpRequest.doGetRequest(url);
    };

    var getPermissions = function (modulekey) {
        //DOM MOVED THIS HERE SO THAT IT WORKS INTHE LOGIN CHAIN
        init();

        if (currentUser == null) {
            return false;
        }

        var currModule = getModule();
        if (currModule == modulekey && taskperms != null) return $q.when();

        setModule(modulekey);
        var allPromises = $q.all([requestTaskPermByModule(modulekey), requestEventPermByModule(modulekey), requestJobPerms()]).then(function (values) {
            taskperms = values[0];
            eventperms = values[1];
            jobperms = values[2];
        });
        return allPromises;
    };

    var getDashPermissions = function (modulekey) {
        return $q(function (resolve, reject) {
            if (currentUser == null) {
                reject();
            }
            requestEventPermByModule(modulekey).then(function (value) {
                dasheventperms = value;
                resolve();
            });
        });
    };

    var getAdditionalTaskPerm = function (taskKey) {
        return $q(function (resolve, reject) {
            if (currentUser == null) {
                reject();
            }
            requestAdditionalTaskPerm(taskKey).then(function (taskPermArray) {
                taskperms.push(taskPermArray[0]);
                resolve();
            });
        });
    };

    var getPermissionsByMenuGroup = function (groupKey) {

        //DOM MOVED THIS HERE SO THAT IT WORKS INTHE LOGIN CHAIN
        init();

        if (currentUser == null) {
            return false;
        }

        var currGroup = getMenuGroup();
        if (currGroup == groupKey && grouptaskperms != null) return $q.when();

        setMenuGroup(groupKey);
        return $q(function (resolve, reject) {
            requestTaskPermByMenuGroup(groupKey).then(function (taskPerms) {
                grouptaskperms = taskPerms;
                resolve();
            });
        });
    };

    // from DB
    var getUserPermByTask = function (taskkey) {
        var url = baseurl + "usertaskperms/GetByTask?userid=" + currentUser.UserID + "&lockey=" + lockey + "&taskkey=" + taskkey;
		return httpRequest.doGetRequest(url);
    };

    // from DB
    var getUserPermByEvent = function (eventkey) {
        var url = baseurl + "usersecureventperms/GetByEvent?userid=" + currentUser.UserID + "&lockey=" + lockey + "&eventkey=" + eventkey;
		return httpRequest.doGetRequest(url);
    };

    // from array
    var getTaskPerms = function (taskkey) {
        for (var i = 0; i < taskperms.length; i++) {
            if (taskperms[i].TaskKey == taskkey && taskperms[i].LocKey == lockey) {
                return taskperms[i].Rights;
            }
        }

        if (userid == 'admin') {
            return 3;
        } else {
            return 1;
        }
    };

    // from array
    var getSecurEventPerms = function (eventkey) {
        for (var i = 0; i < eventperms.length; i++) {
            if (eventperms[i].SecurityEventKey == eventkey && eventperms[i].LocKey == lockey) {
                return eventperms[i].Authorized;
            }
        }
        return false;
    };

    var getDashSecurEventPerms = function (eventkey) {
        for (var i = 0; i < dasheventperms.length; i++) {
            if (dasheventperms[i].SecurityEventKey == eventkey && dasheventperms[i].LocKey == lockey) {
                return dasheventperms[i].Authorized;
            }
        }
        return false;
    };


    var getJAMOdataString = function () {
        
        if (jobperms != null && jobperms.length > 0) {
            return " and ( DALUserID eq '" + userid + "' ) ";

            var filter = " and ((";
            for (var i = 0; i < jobperms.length; i++) {
                if (i == 0) {
                    filter += " JobKey eq " + jobperms[i].JobKey;
                } else {
                    filter += " or JobKey eq " + jobperms[i].JobKey;
                }
            }
            filter += ") )"; // Removed or JobKey eq null .. need job
            return filter;
        } else {
            return " and ( DALUserID eq null ) ";
            return "";
        }
    };

    var getJAMSqlString = function () {
        if (jobperms != null && jobperms.length > 0) {
            return " and ( DALUserID = '" + userid + "' ) "; 
            var filter = " AND ( JobKey IN (";
            for (var i = 0; i < jobperms.length; i++) {
                if (i == 0) {
                    filter += jobperms[i].JobKey;
                } else {
                    filter += "," + jobperms[i].JobKey;
                }
            }
            filter += ")  )"; // Removed or JobKey is null .. need job
            return filter;
        } else {
            return "and ( DALUserID is null )"
            return "";
        }
    };

    var validJAMJob = function (jobKey) {
        if (jobperms != null && jobperms.length > 0) {
            if (jobKey == null) return false; // has to match..

            for (var i = 0; i < jobperms.length; i++) {
                if (jobKey == jobperms[i].JobKey) return true;
            }
            return false;
        }
        return true; // no jam TRUE!

    };

    //DOMINICK COMMENTED OUT
    // init();

    return {
        getPermissions: getPermissions,
        getDashPermissions: getDashPermissions,
        getPermissionsByMenuGroup: getPermissionsByMenuGroup,
        getTasksPerms: function () { return taskperms; },
        getSecurEventsPerms: function () { return eventperms; },
        getJobsPerms: function () { return jobperms; },
        getGroupTasksPerms: function () { return grouptaskperms; },
        setModule: setModule,
        getModule: getModule,
        getTaskPerms: getTaskPerms,
        getSecurEventPerms: getSecurEventPerms,
        getDashSecurEventPerms: getDashSecurEventPerms,
        getUserPermByTask: getUserPermByTask,
        getUserPermByEvent: getUserPermByEvent,
        setNextTask: setNextTask,
        getNextTask: getNextTask,
        getJAMOdataString: getJAMOdataString,
        getJAMSqlString: getJAMSqlString,
        validJAMJob: validJAMJob,
        requestTaskPermByModule: requestTaskPermByModule,
        hasJAMFilter: function () { return (jobperms != null && jobperms.length > 0); },
        getAdditionalTaskPerm: getAdditionalTaskPerm
    };

}